import React, { useEffect } from "react";
import ModakBackdrop from "./ModakBackdrop";
import { useRoundGate } from "./useRoundGate";

export default function ThankYou() {
  const { loading, status } = useRoundGate(null);

  useEffect(() => {
    document.title = "Thank You";
  }, []);

  if (loading || !status) return null;

  return (
    <ModakBackdrop>
      <div className="modak-thankyou">
        <img src="/modak-assets/thankyou1.gif" alt="Thank you" />
        <div className="modak-thankyou-score">
          Your Score is {status.points} out of 47 in {status.time} minutes.
        </div>
      </div>
    </ModakBackdrop>
  );
}
